import React from 'react';
import { injectIntl, type WrappedComponentProps, type MessageDescriptor } from 'react-intl-next';
import type OriginTracing from '@atlassiansox/origin-tracing';
import TemplateList from './template-list';
import { type Template } from '../../../containers/template/types';
import { HeaderContainer, SidebarWrapper, Subtitle, Title } from './styled';
import { useThemeContext } from '../../theme';

interface Props {
	templates: Template[];
	activeTemplate?: Template;
	onTemplateClick?: (template: Template) => void;
	onTemplateMouseEnter?: (template: Template) => void;
	onMouseLeave?: () => void;
	hoverRef?: React.Ref<any>;
	isDisabled: boolean;
	origin?: OriginTracing | null;
	title: MessageDescriptor;
	subtitle: MessageDescriptor;
}

const TemplatesSidebar = ({
	intl,
	templates,
	onTemplateClick,
	onTemplateMouseEnter,
	onMouseLeave,
	hoverRef,
	isDisabled,
	activeTemplate,
	origin,
	title,
	subtitle,
}: Props & WrappedComponentProps) => {
	const theme = useThemeContext();

	return (
		<SidebarWrapper data-test-id="confluence-project-pages.template-sidebar" theme={theme}>
			<HeaderContainer
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={isDisabled ? 'is-disabled' : ''}
				data-testid="confluence-project-pages.template-sidebar-header"
			>
				<Title>{intl.formatMessage(title)}</Title>
				<Subtitle>{intl.formatMessage(subtitle)}</Subtitle>
			</HeaderContainer>
			<TemplateList
				templates={templates}
				activeTemplate={activeTemplate}
				onTemplateClick={onTemplateClick}
				onTemplateMouseEnter={onTemplateMouseEnter}
				onMouseLeave={onMouseLeave}
				hoverRef={hoverRef}
				isDisabled={isDisabled}
				origin={origin}
			/>
		</SidebarWrapper>
	);
};

export default injectIntl(TemplatesSidebar);
